// 1RM-Berechnung (Epley-Formel) und Hilfen.

export function calc1RM(weight, reps) {
    if (reps === 1) return weight;
    return weight * (1 + reps / 30);
}

export function fmt(val) {
    return val.toFixed(1);
}

export const percentages = [100, 95, 90, 85, 80, 75, 70, 65, 60];
